import {CanvasAssignment} from "../../models/canvas/Assignment";

export const MOCK_CANVAS_ASSIGNMENTS: CanvasAssignment[] = [
  {
    "course_id": 17320,
    "name": "Quiz 1: Anatomische termen van positie",
    "grading_type": "points",
    "published": false,
    "points_possible": 10.0,
    "submission_types": [
      "online_quiz"
    ],
    "assignment_group_id": 50521,
    "position": 1,
    "id": 165285
  },
  {
    "course_id": 17320,
    "name": "Quiz 3: Neurotransmitter systemen",
    "grading_type": "points",
    "published": true,
    "points_possible": 10.0,
    "submission_types": [
      "online_quiz"
    ],
    "assignment_group_id": 50521,
    "position": 2,
    "id": 165278
  },
  {
    "course_id": 17320,
    "name": "Quiz 2: Macro Anatomie",
    "grading_type": "points",
    "published": true,
    "points_possible": 10.0,
    "submission_types": [
      "online_quiz"
    ],
    "assignment_group_id": 50521,
    "position": 3,
    "id": 165282
  },
  {
    "course_id": 17320,
    "name": "Quiz 4: Micro anatomie",
    "grading_type": "points",
    "published": true,
    "points_possible": 10.0,
    "submission_types": [
      "online_quiz"
    ],
    "assignment_group_id": 50521,
    "position": 4,
    "id": 165288
  },
  {
    "course_id": 17320,
    "name": "Cijfers deeltoets 1",
    "grading_type": "points",
    "published": true,
    "points_possible": 10.0,
    "submission_types": [
      "on_paper"
    ],
    "assignment_group_id": 50521,
    "position": 5,
    "id": 181676
  },
  {
    "course_id": 17320,
    "name": "Cijfers deeltoets 2",
    "grading_type": "points",
    "published": true,
    "points_possible": 10.0,
    "submission_types": [
      "on_paper"
    ],
    "assignment_group_id": 50521,
    "position": 6,
    "id": 185538
  },
  {
    "course_id": 17320,
    "name": "Cijfer presentatie",
    "grading_type": "points",
    "published": true,
    "points_possible": 10.0,
    "submission_types": [
      "on_paper"
    ],
    "assignment_group_id": 50521,
    "position": 7,
    "id": 186418
  },
  {
    "course_id": 17320,
    "name": "Cijfer deeltoets 3",
    "grading_type": "points",
    "published": true,
    "points_possible": 10.0,
    "submission_types": [
      "on_paper"
    ],
    "assignment_group_id": 50521,
    "position": 8,
    "id": 192341
  },
  {
    "course_id": 17320,
    "name": "Perusall assignment 1",
    "grading_type": "points",
    "published": true,
    "points_possible": 10.0,
    "submission_types": [
      "external_tool"
    ],
    "assignment_group_id": 50519,
    "position": 1,
    "id": 165305
  },
  {
    "course_id": 17320,
    "name": "Perusall assignment 2",
    "grading_type": "points",
    "published": true,
    "points_possible": 10.0,
    "submission_types": [
      "external_tool"
    ],
    "assignment_group_id": 50519,
    "position": 2,
    "id": 165306
  },
  {
    "course_id": 17320,
    "name": "Perusall assignment 3",
    "grading_type": "points",
    "published": true,
    "points_possible": 10.0,
    "submission_types": [
      "external_tool"
    ],
    "assignment_group_id": 50519,
    "position": 3,
    "id": 165307
  },
  {
    "course_id": 17320,
    "name": "Artikelen college DSM",
    "grading_type": "points",
    "published": true,
    "points_possible": 0.0,
    "submission_types": [
      "none"
    ],
    "assignment_group_id": 50519,
    "position": 7,
    "id": 165294
  },
  {
    "course_id": 17320,
    "name": "Artikelen college Alzheimer",
    "grading_type": "points",
    "published": true,
    "points_possible": 1.0,
    "submission_types": [
      "none"
    ],
    "assignment_group_id": 50519,
    "position": 8,
    "id": 165292
  },
  {
    "course_id": 17320,
    "name": "Artikelen college Migraine",
    "grading_type": "points",
    "published": false,
    "points_possible": 1.0,
    "submission_types": [
      "none"
    ],
    "assignment_group_id": 50519,
    "position": 9,
    "id": 165297
  },
  {
    "course_id": 17320,
    "name": "Artikelen college Epilepsie",
    "grading_type": "points",
    "published": false,
    "points_possible": 0.0,
    "submission_types": [
      "none"
    ],
    "assignment_group_id": 50519,
    "position": 10,
    "id": 165296
  },
  {
    "course_id": 17320,
    "name": "Artikelen college Eetstoornissen",
    "grading_type": "points",
    "published": false,
    "points_possible": 0.0,
    "submission_types": [
      "none"
    ],
    "assignment_group_id": 50519,
    "position": 11,
    "id": 165295
  },
  {
    "course_id": 17320,
    "name": "Artikelen college Pijn en Angst",
    "grading_type": "points",
    "published": false,
    "points_possible": 0.0,
    "submission_types": [
      "none"
    ],
    "assignment_group_id": 50519,
    "position": 12,
    "id": 165298
  },
  {
    "course_id": 17320,
    "name": "Artikel college MS",
    "grading_type": "points",
    "published": false,
    "points_possible": 0.0,
    "submission_types": [
      "none"
    ],
    "assignment_group_id": 50519,
    "position": 13,
    "id": 165291
  },
  {
    "course_id": 17320,
    "name": "Artikelen college Depressie",
    "grading_type": "points",
    "published": false,
    "points_possible": 0.0,
    "submission_types": [
      "none"
    ],
    "assignment_group_id": 50519,
    "position": 14,
    "id": 165293
  }
]